import * as React from 'react';
import { useSelector } from 'react-redux';
import { NewBuildingLabels as NewBuildingLabelsComponent } from '../../components/NewBuildingLabels';
import { getNewBuildingLabels } from '../../selectors';
import { IApplicationState } from '../../types/redux';

interface INewBuildingLabelsProps {
  newBuildingId: number;
}

export function NewBuildingLabels({ newBuildingId }: INewBuildingLabelsProps) {
  const labels = useSelector((state: IApplicationState) => getNewBuildingLabels(state, newBuildingId));

  if (!labels.length) {
    return null;
  }

  return <NewBuildingLabelsComponent labels={labels} />;
}
